import axios from 'axios';
const event = {
    
	actions: {
		processevent(context, userdata){
			return new Promise((resolve, reject) => {				
				axios({url: '/Event/ProcessEvent', data: userdata, method: 'POST' })
				.then(resp => resp.data)
				.then(respdata => {	                   									
					resolve(respdata)
				})
				.catch(err => {									
					reject(err)
				})
			})
		},	
		getevent({rootState}){
			return new Promise((resolve, reject) => {				
				axios.get('/Event/GetEvent?Username='+rootState.auth.token)
				.then(resp => resp.data)
				.then(respdata => {					
					resolve(respdata)
				})
				.catch(err => {					
					reject(err)
				})
			})
		},   
		geteventbyid({rootState},Id){
			return new Promise((resolve, reject) => {				
				axios.get('/Event/GetEventbyId?Id='+Id+'&Username='+rootState.auth.token)
				.then(resp => resp.data)
				.then(respdata => {					
					resolve(respdata)
				})
				.catch(err => {					
					reject(err)
				})
			})
		},   
		geteventbysearch({rootState},searchVal){
			return new Promise((resolve, reject) => {				
				axios.get('/Event/GetEventbySearch?SearchItem='+searchVal+'&Username='+rootState.auth.token)
				.then(resp => resp.data)
				.then(respdata => {					
					resolve(respdata)
				})
				.catch(err => {					
					reject(err)
				})
			})
		}    
	}
}

export default event